import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, map, mergeMap } from 'rxjs/operators';

import { DwComponent, DwComponentType, DwPillItem, DwUiConfigRegistryService } from '@devwareapps/devware-cap';
import { SchoolFeatures } from '../../../schools/models/school-features.model';
import { SchoolRepositoryService } from '../../../schools/services/school-repository.service';
import { UnlimitedCourseAccessService } from '../../services/unlimited-course-access.service';

// Matches /my-courses/view/:courseId/module/:moduleId exactly (no trailing
// /lesson/...). When true we render the editorial ModuleDetailViewComponent
// instead of DevWare's default form view.
const MODULE_DETAIL_URL = /^\/my-courses\/view\/\d+\/module\/\d+\/?(?:\?.*)?$/;

// Matches /my-courses/view/:courseId exactly (no trailing /module/...). When
// true we render the editorial CourseDetailViewComponent — the redesigned
// course landing page that replaces the metadata-driven form view.
const COURSE_DETAIL_URL = /^\/my-courses\/view\/\d+\/?(?:\?.*)?$/;


@DwComponent({
  key: 'CousrsePage',
  name: 'Course Page',
  componentType: DwComponentType.pageComponent,
  isGlobal: true
})
@Component({
  selector: 'app-course-page',
  templateUrl: './course-page.component.html',
  styleUrls: ['./course-page.component.scss']
})
export class CoursePageComponent implements OnInit, OnDestroy {

  schoolFeatures: SchoolFeatures;
  readonly courseSkeletonCards = [1, 2, 3];
  readonly myCoursesFilters = {};
  readonly marketplaceFilters = {};
  myCoursesLoading = true;
  marketplaceLoading = true;
  showAvailableCourses = false;
  availableCoursesTitle = 'Marketplace';

  showModuleDetail = false;
  showCourseDetail = false;

  myCoursesTab: DwPillItem = {
    display: 'My Courses',
    value: 'my-courses',
    iconClass: 'fa fa-book',
    tooltip: 'My Courses'
  };

  marketplaceTab: DwPillItem = {
    display: 'Marketplace',
    value: 'marketplace',
    iconClass: 'fa fa-cart-plus',
    tooltip: 'Marketplace to buy courses'
  };

  tabs: any[];

  currentTab: string;

  showTabs = true;

  private routerSub?: Subscription;

  constructor(
    private schoolRepositoryService: SchoolRepositoryService,
    private dwUiConfigRegistraty: DwUiConfigRegistryService,
    private router: Router,
    private unlimitedCourseAccessService: UnlimitedCourseAccessService,
  ) { }

  ngOnInit(): void {
    this.tabs = [this.myCoursesTab, this.marketplaceTab];

    this.currentTab = this.myCoursesTab.value;

    this.schoolRepositoryService.getSchoolFeatures()
      .pipe(mergeMap(features => this.unlimitedCourseAccessService.hasAccess(features)
        .pipe(map(hasAccess => ({ features, hasAccess })))))
      .subscribe(({ features, hasAccess }) => {
        this.schoolFeatures = features;
        this.showAvailableCourses = !!features?.IsMarketplaceEnabled || hasAccess;
        this.availableCoursesTitle = hasAccess && !features?.IsMarketplaceEnabled
          ? 'Available Courses'
          : 'Marketplace';
      });

      this.setupReloadDebugging();
    // this.evaluateUrl(this.router.url);

    // this.routerSub = this.router.events.pipe(
    //   filter((e): e is NavigationEnd => e instanceof NavigationEnd)
    // ).subscribe(e => this.evaluateUrl(e.urlAfterRedirects ?? e.url));

    //DwUiConfigRegistryService.logRegistrations();
  }

  setupReloadDebugging() {
    window.addEventListener('beforeunload', (event) => {
      console.trace('FULL BROWSER UNLOAD DETECTED');
    });
  }

  ngOnDestroy(): void {
    // this.routerSub?.unsubscribe();
  }

  setPillsTab(tabKey: string) {

  }

  onDataLoadComplete(section: 'myCourses' | 'marketplace') {
    setTimeout(() => {
      if (section === 'myCourses') {
        this.myCoursesLoading = false;
        return;
      }

      this.marketplaceLoading = false;
    }, 400);
  }

  private evaluateUrl(url: string): void {
    this.showModuleDetail = MODULE_DETAIL_URL.test(url);
    this.showCourseDetail = !this.showModuleDetail && COURSE_DETAIL_URL.test(url);
  }
}
